import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { CentrosComponent } from './components/centros/centros.component';
import { GruposComponent } from './components/grupos/grupos.component';
import { PersonasComponent } from './components/personas/personas.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { EmpleoComponent } from './components/empleo/empleo.component';
import { SeguimientoComponent } from './components/beneficiarios/seguimiento.component';
import { HeaderComponent } from './components/header/header.component';
import { GoogleMapsService } from './services/google-maps.service';
import { CsvService } from './services/csv.service';
import { SplitButtonModule } from 'primeng/splitbutton';

// NGRX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { appReducers } from './store/app.reducers';
import { ServiciosEffects } from './store/effects/servicios.effects';
import { CentrosEffects } from './store/effects/centros.effects';
import { EmpleosEffects } from './store/effects/empleos.effects';
import { PersonasEffects } from './store/effects/personas.effects';
import { GruposEffects } from './store/effects/grupos.effects';
import { ProgramasEffects } from './store/effects/programas.effects';
import { InstitucionesEffects } from './store/effects/instituciones.effects';
import { BeneficiariosEffects } from './store/effects/beneficiarios.effects';
import { FormulariosEffects } from './store/effects/formularios.effects';
import { environment } from 'src/environments/environment';

// PRIMENG
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TooltipModule } from 'primeng/tooltip';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { PickListModule } from 'primeng/picklist';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GMapModule } from 'primeng/gmap';
import { KeyFilterModule } from 'primeng/keyfilter';
import { CaptchaModule } from 'primeng/captcha';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';

import { DownloadService } from './services/download.service';
import { DatePipe } from '@angular/common';
import { LoginComponent } from './components/login/login.component';
import { AuthenticationService } from './services/authentication.service';
import { AuthEffects } from './store/effects/auth.effects';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { EstudioComponent } from './forms/estudio/estudio.component';
import { InstitucionesComponent } from './components/instituciones/instituciones.component';
import { ProgramasComponent } from './components/programas/programas.component';
import { FormulariosComponent } from './components/formularios/formularios.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CentrosComponent,
    GruposComponent,
    PersonasComponent,
    ServiciosComponent,
    EmpleoComponent,
    SeguimientoComponent,
    HeaderComponent,
    LoginComponent,
    EstudioComponent,
    InstitucionesComponent,
    ProgramasComponent,
    FormulariosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CardModule,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TableModule,
    DropdownModule,
    CalendarModule,
    InputTextModule,
    InputTextareaModule,
    TooltipModule,
    ListboxModule,
    SidebarModule,
    MultiSelectModule,
    DialogModule,
    ConfirmDialogModule,
    GMapModule,
    ProgressSpinnerModule,
    ToastModule,
    CaptchaModule,
    KeyFilterModule,
    SplitButtonModule,
    PickListModule,
    ProgressBarModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot([ServiciosEffects, FormulariosEffects, CentrosEffects, EmpleosEffects, PersonasEffects, GruposEffects, BeneficiariosEffects, AuthEffects, ProgramasEffects, InstitucionesEffects]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    !environment.production ? StoreDevtoolsModule.instrument() : []
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    ConfirmationService,
    GoogleMapsService,
    DownloadService,
    AuthenticationService,
    CsvService,
    MessageService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
